import {
	RESET_STATE,
	SET_AUTOPARKS,
	SET_CONFIGS,
	SET_IS_AUTOPARKS_LOADING,
	SET_IS_CONFIGS_LOADING,
	SET_IS_MODES_LOADING,
	SET_IS_PLANNING_LOADING,
	SET_IS_TARIFF_TYPES_LOADING,
	SET_IS_TRANSPORT_TYPES_LOADING,
	SET_MODES,
	SET_ORDER_GROUP_INFO,
	SET_ORDER_GROUP_INFO_LOADING,
	SET_TARIFF_TYPES,
	SET_TRANSPORT_TYPES,
} from './actions';

export const initialState = {
	configs: null,
	isConfigsLoading: false,
	transportTypes: null,
	isTransportTypesLoading: false,
	orderGroupInfo: null,
	isOrderGroupInfoLoading: false,
	isPlanningLoading: false,
	modes: null,
	isModesLoading: false,
	autoparks: null,
	isAutoparksLoading: false,
	tariffTypes: null,
	isTariffTypesLoading: false,
};

const orderGroupsPlanningContainerReducer = (state = initialState, action) => {
	const { type, payload } = action;

	switch (type) {
		case SET_CONFIGS:
			return {
				...state,
				configs: payload,
			};
		case SET_IS_CONFIGS_LOADING:
			return {
				...state,
				isConfigsLoading: payload,
			};
		case SET_TRANSPORT_TYPES:
			return {
				...state,
				transportTypes: payload,
			};
		case SET_IS_TRANSPORT_TYPES_LOADING:
			return {
				...state,
				isTransportTypesLoading: payload,
			};
		case SET_ORDER_GROUP_INFO:
			return { ...state, orderGroupInfo: payload };
		case SET_ORDER_GROUP_INFO_LOADING:
			return { ...state, isOrderGroupInfoLoading: payload };
		case SET_IS_PLANNING_LOADING:
			return {
				...state,
				isPlanningLoading: payload,
			};
		case SET_MODES:
			return {
				...state,
				modes: payload,
			};
		case SET_IS_MODES_LOADING:
			return {
				...state,
				isModesLoading: payload,
			};
		case SET_AUTOPARKS:
			return {
				...state,
				autoparks: payload,
			};
		case SET_IS_AUTOPARKS_LOADING:
			return {
				...state,
				isAutoparksLoading: payload,
			};
		case SET_TARIFF_TYPES:
			return {
				...state,
				tariffTypes: payload,
			};
		case SET_IS_TARIFF_TYPES_LOADING:
			return {
				...state,
				isTariffTypesLoading: payload,
			};
		case RESET_STATE:
			return initialState;
		default:
			return state;
	}
};

export default orderGroupsPlanningContainerReducer;
